(()=>{document.addEventListener('click',e=>{const card=e.target.closest('[data-h-v3-product-card]');if(!card)return;const panel=card.querySelector('[data-h-v3-quick-panel]');const trigger=e.target.closest('[data-h-v3-quick-trigger]');const close=e.target.closest('[data-h-v3-quick-close]');const swatch=e.target.closest('[data-h-v3-swatch]');const size=e.target.closest('[data-h-v3-size]');let variants=[];try{variants=JSON.parse(card.querySelector('[data-h-v3-variants]')?.textContent||'[]')}catch(_){}
if(trigger&&panel){panel.hidden=!panel.hidden;trigger.setAttribute('aria-expanded',String(!panel.hidden));return}
if(close&&panel){panel.hidden=true;card.querySelector('[data-h-v3-quick-trigger]')?.setAttribute('aria-expanded','false');return}
if(swatch){card.querySelectorAll('[data-h-v3-swatch]').forEach(x=>x.classList.remove('is-active'));swatch.classList.add('is-active');const input=card.querySelector('[data-h-v3-variant-input]');if(input)input.value=swatch.dataset.variantId||input.value;const img=card.querySelector('.h-v3-card__image--primary');if(img&&swatch.dataset.imageSrc)img.src=swatch.dataset.imageSrc;const link=card.querySelector('[data-h-v3-product-link]');if(link&&swatch.dataset.variantUrl)link.href=swatch.dataset.variantUrl;return}
if(size){card.querySelectorAll('[data-h-v3-size]').forEach(x=>x.classList.remove('is-active'));size.classList.add('is-active');const chosen=size.dataset.size;const activeSwatch=card.querySelector('[data-h-v3-swatch].is-active');let baseVariant=activeSwatch?variants.find(v=>String(v.id)===activeSwatch.dataset.variantId):null;let candidate=variants.find(v=>v.available&&v.options.includes(chosen)&&(!baseVariant||v.options.some((o,i)=>o===baseVariant.options[i])));if(!candidate)candidate=variants.find(v=>v.available&&v.options.includes(chosen));const input=card.querySelector('[data-h-v3-variant-input]');if(candidate&&input)input.value=candidate.id}
})})();
/* Collection V3 Main Controls */
document.addEventListener('change',function(e){var sort=e.target.closest('[data-h-v3-sort]');if(!sort)return;var url=new URL(window.location.href);url.searchParams.set('sort_by',sort.value);window.location.href=url.toString();});
document.addEventListener('click',function(e){var btn=e.target.closest('[data-h-v3-grid]');if(!btn)return;var grid=document.querySelector('[data-h-v3-grid-container]');if(!grid)return;grid.dataset.gridColumns=btn.dataset.hV3Grid;document.querySelectorAll('[data-h-v3-grid]').forEach(function(x){x.classList.remove('is-active')});btn.classList.add('is-active');});


/* HARPAH Collection V3 — Filter Drawer */
(() => {
  const root = document.querySelector('[data-h-v3-filter-root]');
  if (!root) return;

  const drawer = root.querySelector('[data-h-v3-filter-drawer]');
  const form = root.querySelector('[data-h-v3-filter-form]');
  const triggers = document.querySelectorAll('[data-h-v3-filter-trigger]');
  const closers = root.querySelectorAll('[data-h-v3-filter-close]');
  let lastFocused = null;

  const colourMap = {
    black:'#111111', white:'#ffffff', ivory:'#f4f0e8', cream:'#eee7dc',
    beige:'#d8c8b4', brown:'#7a5a44', navy:'#1f2a44', blue:'#6e8da8',
    red:'#9f3f3f', pink:'#d8a2ad', grey:'#a3a3a3', gray:'#a3a3a3',
    green:'#6f846f', olive:'#77765c', purple:'#8b769b', charcoal:'#4c4c4c',
    stone:'#b8afa5', sand:'#cdbda8', mocha:'#8a6c5b'
  };

  root.querySelectorAll('[data-h-v3-filter-colour]').forEach(el => {
    const name = (el.dataset.colourName || '').trim().toLowerCase();
    el.style.background = colourMap[name] || '#d6d0c9';
  });

  const open = (trigger) => {
    lastFocused = trigger || document.activeElement;
    root.classList.add('is-open');
    document.documentElement.classList.add('h-v3-filter-lock');
    triggers.forEach(btn => btn.setAttribute('aria-expanded', 'true'));
    window.requestAnimationFrame(() => drawer?.focus());
  };

  const close = () => {
    root.classList.remove('is-open');
    document.documentElement.classList.remove('h-v3-filter-lock');
    triggers.forEach(btn => btn.setAttribute('aria-expanded', 'false'));
    lastFocused?.focus?.();
  };

  triggers.forEach(trigger => trigger.addEventListener('click', () => open(trigger)));
  closers.forEach(closer => closer.addEventListener('click', close));

  document.addEventListener('keydown', event => {
    if (!root.classList.contains('is-open')) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
    }
  });

  if (form) {
    form.addEventListener('submit', () => {
      form.querySelectorAll('input[type="number"]').forEach(input => {
        if (input.value === '') input.disabled = true;
      });
    });
  }
})();


/* HARPAH Collection V3 — AJAX Load More + URL / History State */
(() => {
  const section = document.querySelector('[data-h-collection-v3]');
  if (!section) return;

  const grid = section.querySelector('[data-h-v3-grid-container]');
  if (!grid) return;

  const HISTORY_KEY = 'harpahCollectionV3';
  const productSelector = '[data-h-v3-product-card]';

  const getPagination = () => section.querySelector('[data-h-v3-pagination]');
  const getLoadMore = () => section.querySelector('[data-h-v3-load-more]');

  const saveState = (url, page, scrollY = window.scrollY) => {
    const state = {
      ...(history.state || {}),
      [HISTORY_KEY]: {
        url,
        page,
        scrollY
      }
    };
    history.replaceState(state, '', url);
  };

  // Establish a useful baseline state for the first page.
  if (!(history.state && history.state[HISTORY_KEY])) {
    saveState(window.location.href, Number(getPagination()?.dataset.currentPage || 1));
  }

  const rehydrateHelpers = (scope) => {
    // Colour swatches inserted through AJAX need their visual chip colour.
    const colourMap = {
      black:'#111111', white:'#ffffff', ivory:'#f4f0e8', cream:'#eee7dc',
      beige:'#d8c8b4', brown:'#7a5a44', navy:'#1f2a44', blue:'#6e8da8',
      red:'#9f3f3f', pink:'#d8a2ad', grey:'#a3a3a3', gray:'#a3a3a3',
      green:'#6f846f', olive:'#77765c', purple:'#8b769b', charcoal:'#4c4c4c',
      stone:'#b8afa5', sand:'#cdbda8', mocha:'#8a6c5b'
    };

    scope.querySelectorAll?.('[data-h-v3-swatch-dot]').forEach(dot => {
      const name = (dot.dataset.swatchName || '').trim().toLowerCase();
      dot.style.background = colourMap[name] || '#d8d4ce';
    });
  };

  const setLoading = (button, isLoading) => {
    if (!button) return;
    button.classList.toggle('is-loading', isLoading);
    button.setAttribute('aria-busy', String(isLoading));
    const label = button.querySelector('[data-h-v3-load-more-label]');
    if (label) label.textContent = isLoading ? 'Loading…' : 'Show more';
  };

  const showError = (message) => {
    let error = section.querySelector('.h-v3-load-more-error');
    if (!error) {
      error = document.createElement('p');
      error.className = 'h-v3-load-more-error';
      getPagination()?.after(error);
    }
    error.textContent = message;
  };

  const clearError = () => {
    section.querySelector('.h-v3-load-more-error')?.remove();
  };

  const appendProductsFromDocument = (doc) => {
    const nextGrid = doc.querySelector('[data-h-v3-grid-container]');
    if (!nextGrid) throw new Error('Product grid not found in next page.');

    const existingIds = new Set(
      Array.from(grid.querySelectorAll(productSelector))
        .map(card => card.dataset.productId)
        .filter(Boolean)
    );

    const fragment = document.createDocumentFragment();
    let appended = 0;

    nextGrid.querySelectorAll(productSelector).forEach(card => {
      const id = card.dataset.productId;
      if (id && existingIds.has(id)) return;
      existingIds.add(id);
      fragment.appendChild(card);
      appended += 1;
    });

    rehydrateHelpers(fragment);
    grid.appendChild(fragment);
    return appended;
  };

  const replacePaginationFromDocument = (doc) => {
    const current = getPagination();
    const incoming = doc.querySelector('[data-h-v3-pagination]');

    if (current && incoming) {
      current.replaceWith(incoming);
      return incoming;
    }

    if (current && !incoming) {
      current.remove();
      return null;
    }

    if (!current && incoming) {
      grid.after(incoming);
      return incoming;
    }

    return null;
  };

  const loadMore = async (button) => {
    if (!button || button.classList.contains('is-loading')) return;

    clearError();
    setLoading(button, true);
    grid.classList.add('is-loading-more');

    const nextUrl = new URL(button.href, window.location.origin);

    try {
      const response = await fetch(nextUrl.toString(), {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin'
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const appended = appendProductsFromDocument(doc);
      if (!appended) throw new Error('No new products returned.');

      const newPagination = replacePaginationFromDocument(doc);
      const loadedPage = Number(
        newPagination?.dataset.currentPage ||
        nextUrl.searchParams.get('page') ||
        1
      );

      // The visible catalogue now represents this page depth.
      const state = {
        [HISTORY_KEY]: {
          url: nextUrl.toString(),
          page: loadedPage,
          scrollY: window.scrollY
        }
      };
      history.pushState(state, '', nextUrl.toString());

      // Store enough metadata for a natural Back/Forward experience.
      saveState(window.location.href, loadedPage);

    } catch (error) {
      console.error('[HARPAH Collection V3] Load more failed:', error);
      showError('We could not load more products. Please try again.');
      setLoading(button, false);
    } finally {
      grid.classList.remove('is-loading-more');
    }
  };

  section.addEventListener('click', event => {
    const button = event.target.closest('[data-h-v3-load-more]');
    if (!button) return;
    event.preventDefault();
    loadMore(button);
  });

  // Keep scroll position current in history without hammering replaceState.
  let scrollTimer = null;
  window.addEventListener('scroll', () => {
    window.clearTimeout(scrollTimer);
    scrollTimer = window.setTimeout(() => {
      const pagination = getPagination();
      const page = Number(
        pagination?.dataset.currentPage ||
        new URL(window.location.href).searchParams.get('page') ||
        1
      );
      saveState(window.location.href, page, window.scrollY);
    }, 180);
  }, { passive: true });

  // When arriving back from a PDP, browsers usually restore the DOM via bfcache.
  // This explicitly restores saved position when that state exists.
  window.addEventListener('pageshow', event => {
    const saved = history.state?.[HISTORY_KEY];
    if (saved && typeof saved.scrollY === 'number' && event.persisted) {
      window.requestAnimationFrame(() => window.scrollTo(0, saved.scrollY));
    }
  });

  // If browser history changes to a different canonical collection page,
  // use the server-rendered URL. This avoids trying to reverse appended DOM.
  window.addEventListener('popstate', event => {
    const saved = event.state?.[HISTORY_KEY];
    if (!saved) return;

    const target = new URL(saved.url, window.location.origin);
    const current = new URL(window.location.href);

    if (target.toString() !== current.toString()) {
      window.location.href = target.toString();
    }
  });

  rehydrateHelpers(section);
})();


/* =========================================================
   HARPAH COLLECTION V3 — QUICK ADD -> CART DRAWER V3
   Reuses HARPAH Cart Drawer V3 used by Home/PDP.
   ========================================================= */
(() => {
  const dispatchCartEvents = (detail = {}) => {
    ['cart:refresh', 'cart:updated', 'cart:open'].forEach(name => {
      document.documentElement.dispatchEvent(
        new CustomEvent(name, { bubbles: true, detail })
      );
      document.dispatchEvent(
        new CustomEvent(name, { bubbles: true, detail })
      );
    });
  };

  const openHarpahCartDrawer = async (detail = {}) => {
    const api = window.HARPAH_CART_DRAWER_V3;

    try {
      if (api?.refreshAndOpen) {
        await api.refreshAndOpen();
        return;
      }

      if (api?.refresh) {
        await api.refresh();
      }

      if (api?.open) {
        api.open();
        return;
      }

      if (api?.show) {
        api.show();
        return;
      }
    } catch (error) {
      console.warn('[HARPAH Collection V3] HCD3 API fallback:', error);
    }

    dispatchCartEvents(detail);

    window.setTimeout(() => {
      const trigger =
        document.querySelector('.js-drawer-open-cart') ||
        document.querySelector('[data-drawer-id="CartDrawer"]') ||
        document.querySelector('[data-cart-drawer-trigger]') ||
        document.querySelector('[data-hcd3-trigger]');

      if (trigger) {
        trigger.click();
        return;
      }

      const drawer = document.querySelector('[data-hcd3]');
      if (drawer) {
        drawer.setAttribute('aria-hidden', 'false');
        drawer.classList.add('is-open');
      }
    }, 80);
  };

  const getSelectedVariant = (card) => {
    const input = card.querySelector('[data-h-v3-variant-input]');
    return input?.value || null;
  };

  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-h-v3-quick-form]');
    if (!form) return;

    event.preventDefault();

    const card = form.closest('[data-h-v3-product-card]');
    const addButton = form.querySelector('.h-v3-card__add');
    const variantId = getSelectedVariant(card);

    if (!variantId || !addButton) return;

    if (addButton.dataset.loading === 'true') return;

    addButton.dataset.loading = 'true';
    addButton.disabled = true;
    const originalLabel = addButton.textContent;
    addButton.textContent = 'Adding…';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1
        })
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result?.description || result?.message || 'Unable to add product.');
      }

      const panel = card?.querySelector('[data-h-v3-quick-panel]');
      if (panel) panel.hidden = true;

      card?.querySelector('[data-h-v3-quick-trigger]')
        ?.setAttribute('aria-expanded', 'false');

      dispatchCartEvents({ item: result, source: 'collection-v3' });
      await openHarpahCartDrawer({ item: result, source: 'collection-v3' });

      addButton.textContent = 'Added';

      window.setTimeout(() => {
        addButton.textContent = originalLabel || 'Add to bag';
        addButton.disabled = false;
        addButton.dataset.loading = 'false';
      }, 900);

    } catch (error) {
      console.error('[HARPAH Collection V3] Quick add failed:', error);
      addButton.textContent = error.message || 'Try again';
      addButton.disabled = false;
      addButton.dataset.loading = 'false';

      window.setTimeout(() => {
        addButton.textContent = originalLabel || 'Add to bag';
      }, 1800);
    }
  });

  /* Fix size -> exact variant selection by option indices. */
  document.addEventListener('click', event => {
    const sizeButton = event.target.closest('[data-h-v3-size]');
    if (!sizeButton) return;

    const card = sizeButton.closest('[data-h-v3-product-card]');
    if (!card) return;

    let variants = [];
    try {
      variants = JSON.parse(card.querySelector('[data-h-v3-variants]')?.textContent || '[]');
    } catch (_) {
      return;
    }

    const sizeIndexRaw = card.dataset.sizeOptionIndex;
    const colourIndexRaw = card.dataset.colourOptionIndex;
    const sizeIndex = sizeIndexRaw === '' ? null : Number(sizeIndexRaw);
    const colourIndex = colourIndexRaw === '' ? null : Number(colourIndexRaw);

    const chosenSize = sizeButton.dataset.size;
    const activeSwatch = card.querySelector('[data-h-v3-swatch].is-active');
    const activeVariantId = activeSwatch?.dataset.variantId;
    const activeVariant = variants.find(v => String(v.id) === String(activeVariantId));

    const chosenColour =
      colourIndex !== null && activeVariant?.options
        ? activeVariant.options[colourIndex]
        : null;

    const candidate = variants.find(v => {
      if (!v.available || !Array.isArray(v.options)) return false;
      const sizeMatches = sizeIndex === null || v.options[sizeIndex] === chosenSize;
      const colourMatches =
        colourIndex === null ||
        chosenColour === null ||
        v.options[colourIndex] === chosenColour;
      return sizeMatches && colourMatches;
    });

    if (candidate) {
      const input = card.querySelector('[data-h-v3-variant-input]');
      if (input) input.value = candidate.id;

      card.querySelectorAll('[data-h-v3-size]').forEach(btn => {
        btn.classList.toggle('is-active', btn === sizeButton);
      });
    }
  }, true);
})();
